var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "base-dialog",
        {
          attrs: {
            dontShowAgainCookie: _vm.COMPANY_CODE_INFO_MESSAGES_COOKIE_NAME
          },
          model: {
            value: _vm.showCompanyCodeInfoMessagesModal,
            callback: function($$v) {
              _vm.showCompanyCodeInfoMessagesModal = $$v
            },
            expression: "showCompanyCodeInfoMessagesModal"
          }
        },
        _vm._l(_vm.$store.getters["session/companyCodeInfoMessages"], function(
          translation
        ) {
          return _c(
            "b-alert",
            {
              key:
                _vm.$store.getters["session/companyCodeInfoMessages"][
                  translation
                ],
              staticClass: "shadow",
              attrs: { show: "", variant: "info-dialog" }
            },
            [
              _vm._v(
                "\n\t\t\t\t\t" +
                  _vm._s(_vm.$i18nHelpers.normalize(translation)) +
                  "\n\t\t\t\t"
              )
            ]
          )
        }),
        1
      ),
      _vm._v(" "),
      _vm.showHealthSlidersModal ? _c("health-sliders-modal") : _vm._e(),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "neu-cards-ctn", attrs: { cols: "1", "cols-xl": "4" } },
        _vm._l(_vm.blocks, function(block) {
          return _c("PatientPanelServiceBlock", {
            key: block.id,
            attrs: {
              id: block.id,
              title: block.title,
              description: block.description,
              img: block.img,
              action: block.action,
              enabled: block.enabled,
              visible: block.visible,
              active: block.active,
              iconSize: block.iconSize,
              clickOnceEnabled: block.clickOnceEnabled,
              soonLabel: block.soonLabel
            }
          })
        }),
        1
      ),
      _vm._v(" "),
      _c("base-dialog", {
        attrs: {
          content: _vm.$t("patient-panel.evaluateYourHealthWarning"),
          okFn: function async() {
            _vm.goTests()
          },
          cancelFn: function() {
            _vm.testsDialog.visible = false
          },
          dontShowAgainCookie: _vm.testsDialog.cookie,
          dontShowAgainCookieExpirationDays: 90
        },
        model: {
          value: _vm.testsDialog.visible,
          callback: function($$v) {
            _vm.$set(_vm.testsDialog, "visible", $$v)
          },
          expression: "testsDialog.visible"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6bcd9015", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bcd9015","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PatientPanelBlocks.vue
// module id = 3938
// module chunks = 38